// extracted by mini-css-extract-plugin
export default {"language-picker":"BrZ37Az","language-picker__visually-hidden":"JAh_z61","language-picker__select":"KPZdXns","language-picker__icon":"q0I9EBZ"};